'use client';

import { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getPersonCategoryById } from '@/lib/actions/person-categories';
import { CategoryForm } from '@/components/admin/people/CategoryForm';

export default function AdminPersonCategoryEditPage() {
  const { id } = useParams<{ id: string }>();
  const [category, setCategory] = useState<Awaited<ReturnType<typeof getPersonCategoryById>>>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    getPersonCategoryById(id).then((data) => {
      setCategory(data);
      setLoading(false);
    });
  }, [id]);

  if (loading) {
    return null;
  }

  if (!category) {
    return <Navigate to="/admin/people/categories" replace />;
  }

  return <CategoryForm initialData={category} />;
}
